// Default entry point for client scripts
// Automatically generated
// Please avoid from modifying to much...
import * as ReactDOM from "react-dom";
import * as React from "react";
export const render = (type: any, element: HTMLElement) => {
  ReactDOM.render(React.createElement(type, {}), element);
};
// Automatically added for the setaTab tab
export * from "./setaTab/SetaTab";
export * from "./setaTab/SetaTabConfig";
export * from "./setaTab/SetaTabRemove";
